<template>
  <div v-if="this.language == 'eng'">
    <waterfall :col="col" :data="data">
      <template>
        <div
          class="cell-item wow animate__fadeInDown animate__animated"
          @click="goDetail(item.id)"
          v-for="(item, index) in data"
          :key="index"
        >
          <img
            class="image"
            :src="url + item.picture.fileUrl"
          />
          <div class="item-body">
            <div class="item-desc">{{item.englishName}}</div>
            <div class="item-price">￥{{ item.price }}</div>
          </div>
        </div>
      </template>
    </waterfall>
  </div>
  <div v-else-if="this.language == 'en'">
    <waterfall :col="col" :data="data">
      <template>
        <div
          class="cell-item wow animate__fadeInDown animate__animated"
          @click="goDetail(item.id)"
          v-for="(item, index) in data"
          :key="index"
        >
          <img
            class="image"
            :src="url + item.picture.fileUrl"
          />
          <div class="item-body">
            <div class="item-desc">{{ item.zangName }}</div>
            <div class="item-price">￥{{ item.price }}</div>
          </div>
        </div>
      </template>
    </waterfall>
  </div>
  <div v-else>
    <waterfall :col="col" :data="data">
      <template>
        <div
          class="cell-item wow animate__fadeInDown animate__animated"
          @click="goDetail(item.id)"
          v-for="(item, index) in data"
          :key="index"
        >
          <img
            class="image"
            :src="url + item.picture.fileUrl"
          />
          <div class="item-body">
            <div class="item-desc">{{ item.chineseName }}</div>
            <div class="item-price">￥{{ item.price }}</div>
          </div>
        </div>
      </template>
    </waterfall>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      url: process.env.VUE_APP_WEB_URL,
      col: 3,
      language: this.$store.state.language,
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  mounted() {
    new this.$wow.WOW().init();
  },
  methods: {
    goDetail(id) {
      this.$router.push({ path: "/culturalGoodsDetail", query: { id: id } });
    },
  },
};
</script>
<style lang="scss">
.vue-waterfall-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  .cell-item {
    padding: 8px;
    width: 85%;
    margin: 20px 0;
    background: #ffffff;
    border: none !important;
    border-radius: 0 !important;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
    .image {
      width: 100%;
      height: auto;
      display: block;
      transition: all 500ms ease;
    }
    .item-body {
      font-size: 18px;
      font-family: "fangzang";
      padding: 10px 0 0 0;
      .item-desc {
        margin-bottom: 12px;
        white-space: normal;
        word-break: break-word;
      }
      .item-price{
        color: #b8945a;
      }
    }
  }
  .cell-item:hover {
    box-shadow: 0 0 15px #a8a8a8;
    .image {
      transform: scale(1.05);
    }
  }
}
</style>